const remembered = 'trellistry_chunk_reload';
const onceWithinMs = 60_000;

/**
 * A tab left open across a release can ask for a chunk that has gone, and the page fallback may answer with the page
 * rather than a 404. Vite announces that as `vite:preloadError`; the cure is to reload and get the new release. The
 * refresh cookie restores the session. One reload a minute at most, so a file that is truly missing shows its error
 * rather than reloading forever, and none at all if the tab can't remember having tried.
 */
export function reloadOnStaleChunk(
  target: Pick<EventTarget, 'addEventListener'>,
  reload: () => void,
  memory: Pick<Storage, 'getItem' | 'setItem'>,
  now: () => number = Date.now,
): void {
  target.addEventListener('vite:preloadError', (event) => {
    try {
      if (now() - Number(memory.getItem(remembered) ?? 0) < onceWithinMs) return;
      memory.setItem(remembered, String(now()));
    } catch {
      return;
    }
    event.preventDefault();
    reload();
  });
}
